import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';

class CustomerConfOdoo extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
//		console.log("[CustomerConfOdoo.render()]:");
		return (
			<Grid container item direction="column" alignItems="center" justify="center" spacing={1}>
					<Grid container item direction="row" alignItems="center" justify="center" spacing={0}>
						<Grid item xs={3}>
							<FormControlLabel
								disabled 
								control={
									<Checkbox
										defaultChecked={this.props.activeSpecialized}
										value="specialized"
										color="primary"
										name="Specialized"
									/>
								}
								label={this.props.specialized}
							/>
						</Grid>
						<Grid item xs={2}>
							<FormControlLabel
								disabled 
								control={
									<Checkbox
										defaultChecked={this.props.activeUrgent}
										value="specialized"
										color="primary"
										name="activeUrgent"
									/>
								}
								label="Urgent"
							/>
						</Grid>
						<Grid item xs={2}>
							<FormControlLabel
								disabled 
								control={
									<Checkbox
										defaultChecked={this.props.activeAttachment}
										value="specialized"
										color="primary"
										name="activeAttachment"
									/>
								}
								label="Attachment"
							/>
						</Grid>
						<Grid item xs={2}>
							<FormControlLabel
								disabled
								control={
									<Checkbox
										defaultChecked={this.props.seeSuppliers}
										value="specialized"
										color="primary"
										name="seeSuppliers"
									/>
								}
								label="See suppliers"
							/>
						</Grid>
					</Grid>
				</Grid>
		);
	}
}

export default CustomerConfOdoo;